import * as yup from 'yup';

// Define the Yup schema for form validation
export const schema = yup.object().shape({
  name: yup.string().required('Name is required'), // Name field is required
  email: yup.string().email('Invalid email').required('Email is required'), // Email field is required and must be a valid email format
  mobile: yup.string().matches(/^[0-9]{10}$/, 'Invalid mobile number').required('Mobile is required'), // Mobile field is required and must be a valid 10-digit number
  password: yup.string().required('Password is required').min(6, 'Password must be at least 6 characters long'), // Password field is required and must be at least 6 characters long
});
